import { SearchXIcon } from "lucide-react";

import { Alert } from "@/components/base/alert";
import { button } from "@/components/base/button";
import { Link } from "@/components/base/link";
import { title } from "@/components/base/primitives";
import { DefaultLayout } from "@/layouts/default";

export function NotFoundContent() {
  return (
    <DefaultLayout>
      <div className="mx-auto flex max-w-xl flex-col space-y-8 py-16 text-center">
        <div className="mx-auto flex w-full max-w-md flex-col space-y-4 px-3">
          <Alert
            color="info"
            title="Important: System Migration"
            description={
              <div className="flex flex-col space-y-2 text-start">
                <p>
                  We migrated to a new system in <strong>2026</strong>. Its
                  possible you followed a link to a URL for the old site that
                  doesn't exist anymore.
                </p>
                <p>
                  To access your existing account, please use the{" "}
                  <Link
                    to="/account/forgot-password"
                    className="font-medium underline"
                  >
                    Forgot Password
                  </Link>{" "}
                  option to set a new password.
                </p>
              </div>
            }
          />
        </div>
        <div className="flex justify-center">
          <SearchXIcon className="h-16 w-16 text-gray-400" />
        </div>
        <h1 className={title({ size: "lg" })}>Page Not Found</h1>
        <p className="mx-auto max-w-sm text-center text-gray-600">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col justify-center gap-3 pt-4 sm:flex-row">
          <Link to="/" className={button({ color: "primary", radius: "full" })}>
            Go Home
          </Link>
          <Link
            to="/tournaments"
            className={button({
              variant: "outline",
              radius: "full",
              color: "secondary",
            })}
          >
            Browse Tournaments
          </Link>
        </div>
      </div>
    </DefaultLayout>
  );
}
